import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchListData } from '@store/policies/schedule/actions';
import { activeTabSelector } from '@store/policies/schedule/selectors';
import { scheduleViewTabs } from '@store/policies/schedule/utils';
import ViewAllSchedulesButton from './ViewAllSchedulesButton';
import { ScheduleListWrapper } from './styled';
import TopBar from './TopBar';
import Table from './Table';
import Calendar from './Calender';

function ScheduleList({ canEdit }) {
  const dispatch = useDispatch();
  const activeTab = useSelector(activeTabSelector);

  const fetchData = () => dispatch(fetchListData());

  useEffect(() => {
    fetchData();
  }, []);

  // the table is always rendered on first load
  return (
    <ScheduleListWrapper>
      <TopBar />
      {activeTab === scheduleViewTabs.calender ? (
        <Calendar canEdit={canEdit} />
      ) : (
        <Table fetchData={fetchData} canEdit={canEdit} />
      )}
    </ScheduleListWrapper>
  );
}

export default ScheduleList;
export { ViewAllSchedulesButton };
